import { LuBookOpen } from 'react-icons/lu'
import { Link } from 'react-router'
import { ROUTES } from '@/constants/routes'

const tags = [
  'Herbal Consultations',
  'Bio-Scan Assessments',
  'Courses & Workshops',
  'Herbal Products',
  'Community Education',
  'Herbal Walks',
]

const details = [
  { value: '10,000+', label: 'Individuals worked with' },
  { value: '15+', label: 'Years of herb walks' },
  { value: '30+', label: 'Herbal formulas' },
]

export const IntroSection = () => (
  <section
    aria-labelledby="intro-heading"
    className="relative overflow-hidden bg-base-50 py-16 sm:py-20 lg:py-24"
  >
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-start gap-x-14 gap-y-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-y-6">
        <div className="lg:col-start-2 lg:row-start-1">
          <h2
            id="intro-heading"
            className="font-display text-3xl leading-tight tracking-tight text-base-900 sm:text-4xl lg:text-[2.8rem]"
          >
            A Holistic Health &amp;
            <br />
            <span className="text-green-700">Wellness Platform</span>
          </h2>
        </div>
        <div className="mx-auto w-full max-w-md lg:col-start-1 lg:row-start-1 lg:row-span-2">
          <figure className="overflow-hidden rounded-3xl border border-base-200 bg-white p-2 shadow-[0_16px_48px_rgba(26,70,26,0.07)] sm:p-3">
            <img
              src="/holistic-health-overview.png"
              alt="Holistic health for a brighter tomorrow: consultations, nature connection, natural products, educational courses, Bio-Scan assessments, and community engagement."
              width={1254}
              height={1254}
              loading="lazy"
              decoding="async"
              className="h-auto w-full rounded-2xl"
            />
            <figcaption className="px-3 pb-3 pt-5 sm:px-4">
              <p className="font-display text-2xl text-base-900">About Kandake Makonnen</p>
              <p className="mt-1 text-sm text-base-600">
                Medical &amp; Traditional Herbalist | Holistic Consultant | Herbal Formulator
              </p>
              <p className="mt-1 text-sm text-base-600">Founder of Instrumental Health</p>
              <Link
                to={ROUTES.ABOUT}
                className="mt-5 inline-flex min-h-12 w-full items-center justify-center gap-3 rounded-full bg-red-700 px-5 py-3 text-sm font-medium text-white transition-colors hover:bg-red-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-700 focus-visible:ring-offset-4"
              >
                About Kandake <LuBookOpen aria-hidden="true" className="h-4 w-4 shrink-0" />
              </Link>
            </figcaption>
          </figure>
        </div>
        <div className="lg:col-start-2 lg:row-start-2">
          <p className="mt-4 text-base leading-7 text-base-600">
            Instrumental Health is a holistic health and wellness platform founded by Kandake, a
            BSc&nbsp;(Hons) Medical Herbalist with over 30&nbsp;years of holistic health experience
            in traditional and plant-based medicine.
          </p>
          <p className="mt-4 text-base leading-7 text-base-600">
            Rooted in both indigenous healing wisdom and modern scientific training, Instrumental
            Health supports individuals in reconnecting with nature, understanding their bodies, and
            taking conscious control of their health and wellbeing.
          </p>
          <p className="mt-4 text-base leading-7 text-base-600">
            Through herbal consultations, handcrafted products, educational courses, bio-scan
            assessments, and public speaking, Instrumental Health creates practical pathways toward
            healing, empowerment, and long-term wellness.
          </p>

          <div className="mt-7 border-t border-base-200 pt-6">
            <p className="mb-3 text-xs font-medium uppercase tracking-[0.14em] text-green-700">
              Care, learning &amp; connection
            </p>
            <ul className="grid gap-x-5 gap-y-3 sm:grid-cols-2">
              {tags.map((tag) => (
                <li key={tag} className="flex items-center gap-2.5 text-sm text-base-600">
                  <span
                    aria-hidden="true"
                    className="h-1.5 w-1.5 shrink-0 rounded-full bg-green-500"
                  />
                  {tag}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <dl className="mt-10 grid gap-6 rounded-2xl border border-green-100 bg-green-50 p-6 sm:grid-cols-3 sm:gap-8 sm:p-8 lg:mt-12">
        {details.map((detail) => (
          <div key={detail.label} className="flex flex-col items-center text-center">
            <dt className="order-2 mt-2 text-sm leading-relaxed text-green-800">{detail.label}</dt>
            <dd className="order-1 font-display text-4xl leading-none text-green-800 sm:text-5xl">
              {detail.value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  </section>
)
